import { inject, injectable } from "inversify";
import { Types } from "@ioc/types";
import type { IHttpService } from "@modules/infra/http/models/IHttpService";

import { IGetPixByOrderService } from "../models/IGetPixByOrderService";
import { PixApiResponse } from "@pages/User/MyOrders/models/IPixPayment";
import { mapPixApiToPayload } from "@pages/User/MyOrders/utilsOrders/utilsMyOrders";
import { PixPayload } from "@pages/User/MyOrders/models/IPixPayment";

@injectable()
export class GetPixByOrderService implements IGetPixByOrderService {
  @inject(Types.IHttpService)
  private httpInstance!: IHttpService;

  public async execute(salesOrderNumber: string): Promise<PixPayload[]> {
    const response = await this.httpInstance.get<PixApiResponse[]>(
      `/pix/qrcode?salesOrderNumber=${salesOrderNumber}`
    );

    return mapPixApiToPayload(response);
  }

  public async refresh(salesOrderNumber: string, bp: string): Promise<string> {
    const response = await this.httpInstance.post<{ qrcode: string } | string>(
      "/pix/qrcode/refresh",
      { salesOrderNumber, BP: bp }
    );

    if (typeof response === "string") {
      return response;
    }

    const qr = response?.qrcode;
    if (!qr) throw new Error("Refresh não retornou um QR Code válido");
    return qr;
  }
}
